import { Form, Row, Col } from "react-bootstrap";

const LeadAddressTab = () => {
  return (
    <>
      <div className="address-tab">

        {/* ADDRESS */}
        <Form.Group>
          <Form.Label>Address *</Form.Label>
          <Form.Control as="textarea" rows={2} />
        </Form.Group>

        {/* ROW 1 */}
        <Row className="mt-3">
          <Col md={6}>
            <Form.Label>Country *</Form.Label>
            <Form.Select className="custom-select">
              <option>Select</option>
              <option>India</option>
              <option>USA</option>
            </Form.Select>
          </Col>

          <Col md={6}>
            <Form.Label>State *</Form.Label>
            <Form.Select className="custom-select">
              <option>Select</option>
              <option>Telangana</option>
              <option>California</option>
            </Form.Select>
          </Col>
        </Row>

        {/* ROW 2 */}
        <Row className="mt-3">
          <Col md={6}>
            <Form.Label>City *</Form.Label>
            <Form.Select className="custom-select">
              <option>Select</option>
              <option>Hyderabad</option>
              <option>New York</option>
            </Form.Select>
          </Col>

          <Col md={6}>
            <Form.Label>Zipcode *</Form.Label>
            <Form.Control />
          </Col>
        </Row>

      </div>

      {/* STYLES */}
      <style>{`
        .address-tab textarea,
        .address-tab input,
        .address-tab select {
          border-radius: 6px;
        }

        /* SELECT ORANGE FOCUS */
        .custom-select:focus {
          border-color: #ff6b2c;
          box-shadow: 0 0 0 0.2rem rgba(255,107,44,0.2);
        }

        /* SELECTED OPTION ORANGE */
        option:checked {
          background: #ff6b2c;
          color: white;
        }

        /* LABEL */
        .form-label {
          font-weight: 500;
        }

        /* MOBILE */
        @media (max-width: 768px) {
          .row > div {
            margin-bottom: 10px;
          }
        }
      `}</style>
    </>
  );
};

export default LeadAddressTab;